import React, { FC } from 'react';

export const IconCloseSmall: FC<React.PropsWithChildren<{ className?: string }>> = ({ className }) => (
  // @ts-ignore slot attribute is required for market, but not part of the React svg type.
  <svg slot="icon" className={className} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6673 1.33333L1.33398 10.6667" stroke="currentColor" />
    <path d="M1.33464 1.33334L10.668 10.6667" stroke="currentColor" />
  </svg>
);
